export enum SearchResultTypes {
  TopResults = "topResults",
  Teams = "teams",
  Events = "events",
  Products = "products",
  Leagues = "leagues",
  Campaigns = "campaigns",
  Other = "other",
}

export const auctionPlatformSearchTabs = [
  SearchResultTypes.TopResults,
  SearchResultTypes.Teams,
  SearchResultTypes.Events,
  SearchResultTypes.Products,
  SearchResultTypes.Leagues,
  SearchResultTypes.Campaigns,
  SearchResultTypes.Other,
];

export const nonAuctionPlatformSearchTabs = [
  SearchResultTypes.TopResults,
  SearchResultTypes.Teams,
  SearchResultTypes.Products,
  SearchResultTypes.Other,
];

export type CategorySearchResultTypes =
  | SearchResultTypes.Teams
  | SearchResultTypes.Leagues
  | SearchResultTypes.Campaigns
  | SearchResultTypes.Other;

export enum CategoryTrackingMapTypes {
  "teams" = "team",
  "leagues" = "league",
  "campaigns" = "campaign",
  "other" = "other",
}
